import React, { useEffect, useState, } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
} from "adminlte-2-react";

import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import SelectInput from "../utils/SelectInput";
import Loader from "../utils/Loader";

import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

const styles = {
  containerStyle: { maxWidth: 600, marginLeft: "auto", marginRight: "auto" }
};

export default function CrearNotifTemplate({ history, match }) {
  const dispatch = useDispatch();
  const [titulo, setTitulo] = useState(null);
  const [mensaje, setMensaje] = useState(null);
  const [tipo, setTipo] = useState("recordatorio");
  const [periodoCantidad, setPeriodoCantidad] = useState("1");
  const [periodoUnidad, setPeriodoUnidad] = useState("days");
  const [accion, setAccion] = useState("redireccion");
  const [mensajeAccion, setMensajeAccion] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");

  const modelCreacionNotifTemplate = useSelector((state) => {
    return state.creacionNotifTemplate;
  });

  useEffect(() => {
    const data = modelCreacionNotifTemplate?.data?.data;
    const error = modelCreacionNotifTemplate?.error;
    const errorCode = error?.response?.status;
    const errorMessage =
      modelCreacionNotifTemplate?.error?.response?.data?.mensaje;

    if (errorMessage) {
      alert(errorMessage);
    }
    if (error) {

      dispatch(controller.crearNotifTemplateDuck.actions.clear());
    }
    if (data) {
      alert("Creación exitosa");
      dispatch(controller.crearNotifTemplateDuck.actions.clear());
      history.push("/listarNotificaciones");
    }
  }, [modelCreacionNotifTemplate, dispatch]);

  const crearNotifTemplate = () => {
   
    // const token = localStorage.getItem("token");
    let data = {
      titulo,
      mensaje,
      tipo,
      periodoCantidad,
      periodoUnidad,
      accion,
      mensajeAccion: accion === "whatsapp" ? mensajeAccion : null,
      estado,
    };
    dispatch(controller.crearNotifTemplateThunk(data));
  };

  const validateAndSetPeriodoCantidad = (value) => {
    if (value < 0) {
      setPeriodoCantidad(0);
      return;
    }
    setPeriodoCantidad(value);
  };

  const mostrarMensajeAccion = accion === "whatsapp" ? true : false;

  return (
    <Content
      title="Notificación"
      subTitle="Creación"
      browserTitle="Notificación - Creación"
      show={false}
    >
      <Row>
        <Col>
          <Box
            title="Detalles"
            style={styles.containerStyle}
          >

            <ReferenciaObligatorios/>

            <Text
              labelPosition="above"
              size="sm"
              label="Título"
              onChange={(evt) => setTitulo(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Mensaje" obligatorio={true} />}
              onChange={(evt) => setMensaje(evt.target.value)}
              help="Podés utilizar los siguientes placeholders: {{nombre}}, {{clase}} y {{fecha}}"
            />

            <SelectInput
              value={accion}
              setValue={setAccion}
              label="Acción"
              options={[
                { value: "whatsapp", label: "Enviar mensaje vía Whatsapp" },
                { value: "redireccion", label: "Redirección" },
              ]}
            />
            {mostrarMensajeAccion && (
              <Text
                labelPosition="above"
                size="sm"
                label="Mensaje whatsapp"
                onChange={(evt) => setMensajeAccion(evt.target.value)}
              />
            )}
            <SelectInput
              value={tipo}
              setValue={setTipo}
              label="Tipo"
              options={[
                { value: "recordatorio", label: "Recordatorio" },
                { value: "pago", label: "Pago" },
                { value: "inactividad", label: "Inactividad" },
              ]}
            />
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={[
                { value: "ACTIVO", label: "Activo" },
                { value: "INACTIVO", label: "Inactivo" },
              ]}
            />
          </Box>
          <Box
            title="Enviar con anticipación de"
            style={styles.containerStyle}
          >
            <Row>
              <Col xs="12" sm="3">
                <Text
                  inputType="number"
                  labelPosition="none"
                  size="md"
                  // label="Cantidad"
                  value={periodoCantidad}
                  onChange={(evt) => validateAndSetPeriodoCantidad(evt.target.value)}
                />
              </Col>
              <Col xs="12" sm="7">
                <SelectInput
                  value={periodoUnidad}
                  setValue={setPeriodoUnidad}
                  // label="Unidad"
                  labelPosition="none"
                  options={[
                    { value: "hours", label: "Horas" },
                    { value: "days", label: "Días" },
                  ]}
                />
              </Col>
            </Row>
          </Box>
          <Box
            style={styles.containerStyle}
          >

            <Button
              text="Cancelar"
              disabled={false}
              onClick={() => {
                history.push(`/`);
              }}
            />

            <Button
              type="primary"
              text={
                <Loader loaderColor="#ffffff" isLoading={modelCreacionNotifTemplate.loading}>
                  Guardar
                </Loader>
              }
              disabled={modelCreacionNotifTemplate.loading}
              pullRight={true}
              onClick={crearNotifTemplate}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}